export default __webpack_public_path__ + "static/media/phone.f94f5f46.gif";